import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import UpdateRepository from "../Repositories/UpdateRepository";

class UpdateBloc {
  regionCountryChannel = new Subject();
  regionProvinceChannel = new Subject();
  regionCityChannel = new Subject();

  religionChannel = new Subject();
  maritalStatusChannel = new Subject();
  bloodTypeChannel = new Subject();
  bankChannel = new Subject();
  employeeTypeChannel = new Subject();
  employeeStatusChannel = new Subject();
  employeeStatusDescriptionChannel = new Subject();
  employeeStatusPositionChannel = new Subject();
  workUnitChannel = new Subject();

  domicileProvinceChannel = new Subject();
  domicileCityChannel = new Subject();
  domicileDistrictChannel = new Subject();
  domicileVillageChannel = new Subject();
  identityProvinceChannel = new Subject();
  identityCityChannel = new Subject();
  identityDistrictChannel = new Subject();
  identityVillageChannel = new Subject();

  detailChannel = new Subject();
  updateChannel = new Subject();
  inactiveChannel = new Subject();

  satkerGajiWebChannel = new Subject();
  bankSpanGajiWebChannel = new Subject();
  employeeChannel = new Subject();
  repository = new UpdateRepository();

  constructor() {
    this.regionCountryChannel.next({ status: apiResponse.INITIAL });
    this.regionProvinceChannel.next({ status: apiResponse.INITIAL });
    this.regionCityChannel.next({ status: apiResponse.INITIAL });
    this.religionChannel.next({ status: apiResponse.INITIAL });
    this.maritalStatusChannel.next({ status: apiResponse.INITIAL });
    this.bloodTypeChannel.next({ status: apiResponse.INITIAL });
    this.bankChannel.next({ status: apiResponse.INITIAL });
    this.employeeTypeChannel.next({ status: apiResponse.INITIAL });
    this.employeeStatusChannel.next({ status: apiResponse.INITIAL });
    this.employeeStatusDescriptionChannel.next({ status: apiResponse.INITIAL });
    this.employeeStatusPositionChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.domicileProvinceChannel.next({ status: apiResponse.INITIAL });
    this.domicileCityChannel.next({ status: apiResponse.INITIAL });
    this.domicileDistrictChannel.next({ status: apiResponse.INITIAL });
    this.domicileVillageChannel.next({ status: apiResponse.INITIAL });
    this.identityProvinceChannel.next({ status: apiResponse.INITIAL });
    this.identityCityChannel.next({ status: apiResponse.INITIAL });
    this.identityDistrictChannel.next({ status: apiResponse.INITIAL });
    this.identityVillageChannel.next({ status: apiResponse.INITIAL });
    this.detailChannel.next({ status: apiResponse.INITIAL });
    this.updateChannel.next({ status: apiResponse.INITIAL });
    this.inactiveChannel.next({ status: apiResponse.INITIAL });
    this.satkerGajiWebChannel.next({ status: apiResponse.INITIAL });
    this.bankSpanGajiWebChannel.next({ status: apiResponse.INITIAL });
    this.employeeChannel.next({ status: apiResponse.INITIAL });
  }

  fetchRegionCountry = async (query) => {
    try {
      this.regionCountryChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCountry(query)
        .then((result) => {
          this.regionCountryChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCountryChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionProvince = async (query) => {
    try {
      this.regionProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionProvince(query)
        .then((result) => {
          this.regionProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchRegionCity = async (query) => {
    try {
      this.regionCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchRegionCity(query)
        .then((result) => {
          this.regionCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.regionCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchReligion = async (query) => {
    try {
      this.religionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchReligion(query)
        .then((result) => {
          this.religionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.religionChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchMaritalStatus = async (query) => {
    try {
      this.maritalStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchMaritalStatus(query)
        .then((result) => {
          this.maritalStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.maritalStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchBloodType = async (query) => {
    try {
      this.bloodTypeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBloodType(query)
        .then((result) => {
          this.bloodTypeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.bloodTypeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchBank = async (query) => {
    try {
      this.bankChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBank(query)
        .then((result) => {
          this.bankChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.bankChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployeeType = async (query) => {
    try {
      this.employeeTypeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeType(query)
        .then((result) => {
          this.employeeTypeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeTypeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployeeStatus = async (query) => {
    try {
      this.employeeStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeStatus(query)
        .then((result) => {
          this.employeeStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployeeStatusDescription = async (query) => {
    try {
      this.employeeStatusDescriptionChannel.next({
        status: apiResponse.LOADING,
      });
      await this.repository
        .fetchEmployeeStatusDescription(query)
        .then((result) => {
          this.employeeStatusDescriptionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeStatusDescriptionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployeeStatusPosition = async (query) => {
    try {
      this.employeeStatusPositionChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeStatusPosition(query)
        .then((result) => {
          this.employeeStatusPositionChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeStatusPositionChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDomicileProvince = async (query) => {
    try {
      this.domicileProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDomicileProvince(query)
        .then((result) => {
          this.domicileProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.domicileProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDomicileCity = async (query) => {
    try {
      this.domicileCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDomicileCity(query)
        .then((result) => {
          this.domicileCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.domicileCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDomicileDistrict = async (query) => {
    try {
      this.domicileDistrictChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDomicileDistrict(query)
        .then((result) => {
          this.domicileDistrictChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.domicileDistrictChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDomicileVillage = async (query) => {
    try {
      this.domicileVillageChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDomicileVillage(query)
        .then((result) => {
          this.domicileVillageChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.domicileVillageChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchIdentityProvince = async (query) => {
    try {
      this.identityProvinceChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchIdentityProvince(query)
        .then((result) => {
          this.identityProvinceChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.identityProvinceChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchIdentityCity = async (query) => {
    try {
      this.identityCityChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchIdentityCity(query)
        .then((result) => {
          this.identityCityChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.identityCityChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchIdentityDistrict = async (query) => {
    try {
      this.identityDistrictChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchIdentityDistrict(query)
        .then((result) => {
          this.identityDistrictChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.identityDistrictChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchIdentityVillage = async (query) => {
    try {
      this.identityVillageChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchIdentityVillage(query)
        .then((result) => {
          this.identityVillageChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.identityVillageChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchDetail = async (query) => {
    try {
      this.detailChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDetail(query)
        .then((result) => {
          this.detailChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.detailChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchUpdate = async (query) => {
    try {
      this.updateChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchUpdate(query)
        .then((result) => {
          this.updateChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.updateChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchInactive = async (query) => {
    this.inactiveChannel.next({ status: apiResponse.LOADING });
    await this.repository
      .fetchInactive(query)
      .then((result) => {
        this.inactiveChannel.next({
          status: apiResponse.COMPLETED,
          data: result,
        });
      })
      .catch((error) => {
        this.inactiveChannel.next({ status: apiResponse.ERROR, data: error });
      });
  };

  fetchSatkerGajiWeb = async (query) => {
    try {
      this.satkerGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchSatkerGajiWeb(query)
        .then((result) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.satkerGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchBankSpanGajiWeb = async (query) => {
    try {
      this.bankSpanGajiWebChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchBankSpanGajiWeb(query)
        .then((result) => {
          this.bankSpanGajiWebChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.bankSpanGajiWebChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };

  fetchEmployee = async (query) => {
    try {
      this.employeeChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployee(query)
        .then((result) => {
          this.employeeChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "Channel unsubscribed");
    }
  };
}

export default UpdateBloc;
